import { Component, type ErrorInfo, type ReactNode } from 'react'
import { captureError } from '../lib/observability'

type Props = { children: ReactNode }
type State = { hasError: boolean }

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    captureError(error, { componentStack: info.componentStack })
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children

    return (
      <main className="fatal-shell">
        <div className="fatal-card">
          <span className="brand-mark" aria-hidden="true">T</span>
          <p className="eyebrow">Something went out of tune</p>
          <h1>TonalTutor needs a quick reset.</h1>
          <p>Your saved progress is stored on this device and should still be here after reloading.</p>
          <button className="button button-primary" type="button" onClick={() => window.location.reload()}>
            Reload TonalTutor
          </button>
        </div>
      </main>
    )
  }
}
